<template>
  <div class="ban-query-page">
    <NavBar
      class="nav"
      :title="$t('banQuery.封禁查询')"
      :goBack="handleGoBack"
    />

    <div class="page-content">
      <van-form class="query-form" @submit="onSubmit">
        <div class="form-item">
          <div class="form-label">{{ $t("banQuery.选择区服") }}:</div>
          <van-field
            v-model="form.serveInfo.server_name"
            class="query-field"
            readonly
            clickable
            :name="$t('banQuery.选择区服')"
            :placeholder="$t('banQuery.点击选择区服')"
            :rules="[{ required: true, message: $t('banQuery.请选择区服') }]"
            @click="handleServeType"
          />
        </div>

        <div class="form-item">
          <div class="form-label">{{ $t("banQuery.角色名称") }}:</div>
          <van-field
            v-model="form.role"
            class="query-field"
            :name="$t('banQuery.角色名称')"
            :placeholder="$t('banQuery.请输入角色名称')"
            :rules="[
              { required: true, message: $t('banQuery.请输入角色名称') },
            ]"
          />
        </div>

        <div class="submit-area">
          <van-button
            class="login-btn"
            :loading="confirmLoading"
            block
            type="primary"
            size="large"
            native-type="submit"
          >
            {{ $t("banQuery.查询") }}
          </van-button>
          <div class="tip-box">{{ $t("封禁查询提示") }}</div>
        </div>
      </van-form>

      <section v-if="hasRoleResult" class="result-section">
        <div class="section-title">{{ $t("banQuery.角色状态") }}</div>

        <div class="result-row">
          <div class="result-label">{{ $t("当前状态") }}</div>
          <div class="result-value">
            <span class="status-tag" :class="statusTagClass">
              {{ statusDisplayText }}
            </span>
          </div>
        </div>

        <div v-if="showBanDetail" class="result-row">
          <div class="result-label">{{ $t("banQuery.解封时间") }}</div>
          <div class="result-value result-text">{{ roleInfo.time }}</div>
        </div>

        <div v-if="showBanDetail" class="result-row">
          <div class="result-label">{{ $t("banQuery.封禁原因") }}</div>
          <div class="result-value result-text">
            {{ roleInfo.reason }}
          </div>
        </div>

        <div v-if="showBanRecordTextInCard" class="result-row">
          <div class="result-label">{{ $t("banQuery.封禁记录") }}</div>
          <div class="result-value result-text">{{ banInfo.info }}</div>
        </div>

        <van-button
          v-if="showBanDetail"
          class="appeal-button"
          block
          type="primary"
          size="large"
          @click="handleState"
        >
          {{ $t("banQuery.我要申述") }}
        </van-button>
      </section>

      <section v-if="showBanRecordTable" class="record-section">
        <div class="section-title">{{ $t("banQuery.封禁记录") }}</div>

        <div class="record-table">
          <div class="record-header">
            <div class="record-col">{{ $t("banQuery.时间") }}</div>
            <div class="record-col">{{ $t("banQuery.类型") }}</div>
            <div class="record-col">{{ $t("banQuery.原因") }}</div>
          </div>

          <div
            v-for="(item, index) in banInfo.info"
            :key="index"
            class="record-item"
          >
            <div class="record-col">
              {{ item.start_time | timeFilter("YYYY-MM-DD HH:mm") }}
            </div>
            <div class="record-col">
              {{ (item.ban_type && banType[item.ban_type]) || "" }}
            </div>
            <div class="record-col">
              {{ item.reason || item.keyword }}
            </div>
          </div>
        </div>
      </section>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :confirm-button-text="$t('app.确认')"
        :cancel-button-text="$t('app.取消')"
        :columns="currentColumns"
        :loading="pickerLoading"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      >
        <van-search
          slot="title"
          v-model="keyword"
          :placeholder="$t('banQuery.请输入搜索关键词')"
        />
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { getServerList, getServerTypeList, apiGetBanInfo } from "@/api/user";
import { mapState } from "vuex";
import storage from "@/utils/storage";

export default {
  name: "BanQueryRefactor",

  data() {
    return {
      keyword: "",
      pickerLoading: false,
      banType: {
        1: this.$t("banQuery.封号"),
        2: this.$t("banQuery.禁言"),
      },
      form: {
        serveInfo: {},
        role: "",
      },
      columns: [],
      showPicker: false,
      confirmLoading: false,
      serverType: [],
      roleInfo: {
        status: "",
        info: "",
        time: "",
        reason: "",
      },
      banInfo: {
        status: "",
        info: "",
      },
    };
  },

  computed: {
    ...mapState({
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),

    currentColumns() {
      return this.columns.filter((item) => {
        const text = (item.text && item.text.toLowerCase()) || "";
        return text.includes(this.keyword.toLowerCase());
      });
    },

    hasRoleResult() {
      return [0, 1, 2].includes(this.roleInfo.status);
    },

    showBanDetail() {
      return this.roleInfo.status === 1 || this.roleInfo.status === 2;
    },

    showBanRecordTextInCard() {
      return (
        this.hasRoleResult &&
        (this.banInfo.status === 0 || this.banInfo.status === 2)
      );
    },

    showBanRecordTable() {
      return this.banInfo.status === 1;
    },

    statusDisplayText() {
      if (this.roleInfo.status === 0) {
        return this.$t("banQuery.角色状态正常");
      }

      return this.roleInfo.info;
    },

    statusTagClass() {
      return this.roleInfo.status === 0 ? "is-normal" : "is-banned";
    },
  },

  watch: {
    showPicker(value) {
      if (!value) {
        this.keyword = "";
      }
    },
  },

  created() {
    const { game_id } = this.$route.query;

    if (game_id) {
      sessionStorage.setItem("game_id", Number(game_id));
    }

    if (this.defaultRoleInfo.f_id) {
      this.form.role = this.defaultRoleInfo.role_id;
      this.form.serveInfo = {
        server_id: this.defaultRoleInfo.f_id,
        server_name: this.defaultRoleInfo.server_name,
      };
    }
  },

  mounted() {
    this.getServerType();
  },

  methods: {
    handleGoBack() {
      this.$router.go(-1);
    },

    getServerType() {
      getServerTypeList().then((res) => {
        if (res.code === 0) {
          res.data.forEach((item) => {
            item.text = item.name;
          });
          this.serverType = res.data;
        }
      });
    },

    getServerList(id) {
      this.pickerLoading = true;

      getServerList({ server_type: id })
        .then((res) => {
          if (res.code === 0) {
            res.data.forEach((item) => {
              item.text = item.name;
              item.value = item.id;
            });
            this.columns = res.data;
          }
        })
        .finally(() => {
          this.pickerLoading = false;
        });
    },

    handleServeType() {
      this.showPicker = true;
      this.columns = this.serverType;
    },

    onConfirm(value) {
      this.keyword = "";

      if (this.columns === this.serverType) {
        this.getServerList(value.id);
        return;
      }

      this.showPicker = false;
      this.form.serveInfo = {
        server_id: value.id,
        server_name: value.name,
      };
    },

    handleState() {
      this.$router.push({
        name: "Report",
        query: {
          formToken: "f619f7",
          id: 9,
          title: this.$t("banQuery.封禁申述"),
        },
      });
    },

    applyBanQueryResult(payload) {
      const { ban_type, bantime, ban_reason } = payload.data.data;

      if (ban_type === 0) {
        this.roleInfo.status = 0;
        this.roleInfo.info = this.$t("banQuery.角色状态正常");
        this.roleInfo.time = "";
        this.roleInfo.reason = "";
      } else if (ban_type === 1) {
        this.roleInfo.status = 1;
        this.roleInfo.info = this.$t("banQuery.封号中");
        this.roleInfo.time = bantime;
        this.roleInfo.reason = ban_reason;
      } else {
        this.roleInfo.status = 2;
        this.roleInfo.info = this.$t("banQuery.禁言中");
        this.roleInfo.time = bantime;
        this.roleInfo.reason = ban_reason;
      }

      if (!payload.data.isMy) {
        this.banInfo.status = 0;
        this.banInfo.info = this.$t("banQuery.非绑定角色不能查询封禁记录");
      } else if (payload.data.ban_log && payload.data.ban_log.length) {
        this.banInfo.status = 1;
        this.banInfo.info = payload.data.ban_log;
      } else {
        this.banInfo.status = 2;
        this.banInfo.info = this.$t("banQuery.30天内无封禁记录");
      }
    },

    onSubmit() {
      this.confirmLoading = true;

      const { session_id } = this.$route.query;
      const params = {
        server_id: this.form.serveInfo.server_id,
        role: this.form.role,
        session_id: session_id ? Number(session_id) : undefined,
      };

      apiGetBanInfo(params)
        .then((res) => {
          if (res.code === 0) {
            this.$toast(this.$t("查询成功"));
            window.staticFn.customEvent("submit_report", {
              type: "ban_query",
              game_id: storage.getGameId(),
              server_id: this.form.serveInfo.server_id,
              role: this.form.role,
            });
            this.applyBanQueryResult(res);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.ban-query-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #f8f8f8;
}

.nav {
  flex-shrink: 0;
}

.page-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 8px;
  padding: 8px 14px 24px;
  background: #fff;
}

.form-label {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #94979f;
}

.submit-area {
  margin-top: 18px;
}

.login-btn {
  height: 40px;
  font-size: 16px;
  font-weight: 500;
  background: #d4a74f;
  border-color: #d4a74f;
  border-radius: 4px;
}

.tip-box {
  margin-top: 12px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 18px;
  color: #d4a74f;
  text-align: center;
  background: #fff9ef;
  border-radius: 2px;
}

.result-section,
.record-section {
  margin-top: 18px;
}

.section-title {
  position: relative;
  margin-bottom: 12px;
  padding-left: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  color: #353842;
}

.section-title::before {
  position: absolute;
  top: 2px;
  left: 0;
  width: 3px;
  height: 18px;
  content: "";
  background: #d4a74f;
  border-radius: 2px;
}

.result-row {
  display: flex;
  align-items: flex-start;
  padding: 7px 0;
}

.result-label {
  width: 78px;
  flex-shrink: 0;
  font-size: 14px;
  line-height: 22px;
  color: #90949d;
}

.result-value {
  flex: 1;
  min-width: 0;
  text-align: right;
}

.result-text {
  font-size: 14px;
  line-height: 22px;
  color: #666b75;
  word-break: break-word;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  border-radius: 2px;
}

.status-tag.is-normal {
  color: #34b449;
  background: #e9f9e9;
}

.status-tag.is-banned {
  color: #ff5f63;
  background: #fff1f1;
}

.appeal-button {
  height: 40px;
  margin-top: 12px;
  font-size: 16px;
  font-weight: 500;
  background: #d4a74f;
  border-color: #d4a74f;
  border-radius: 4px;
}

.record-table {
  background: #fff;
}

.record-header,
.record-item {
  display: flex;
}

.record-header {
  background: #fafafa;
}

.record-item {
  border-bottom: 1px solid #f3f3f3;
}

.record-col {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 11px 10px;
  font-size: 13px;
  line-height: 18px;
  color: #666b75;
  word-break: break-word;
}

.record-header .record-col {
  color: #9397a0;
}

/deep/ .query-field.van-cell {
  min-height: 48px;
  padding: 0 12px;
  background: #fafafa;
  border-radius: 2px;
}

/deep/ .query-field.van-cell::after {
  display: none;
}

/deep/ .query-field .van-field__body {
  min-height: 48px;
}

/deep/ .query-field .van-field__control,
/deep/ .query-field .van-field__control::placeholder,
/deep/ .query-field .van-cell__value {
  color: #5d6169;
  font-size: 16px;
  font-weight: 500;
}

/deep/ .van-search {
  padding: 0;
}
</style>
